import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { isMobile } from "react-device-detect";
import { BOX_SHADOWS, FONTS } from "../constants";
import { Line } from "../dashboard/Common/BoxHeader";
import styles from "./list.module.css";

const batch_chart = "https://batch-32.imgix.net/batch_chart.png";
const batch_pie = "https://batch-32.imgix.net/batch_pie.png";
const batch_probs = "https://batch-32.imgix.net/batch_probs.png";
const cor1 = "https://batch-32.imgix.net/correlations1.png";
const cor2 = "https://batch-32.imgix.net/correlations2_resize.png";
const dist = "https://batch-32.imgix.net/dist.png";
const impact = "https://batch-32.imgix.net/impact.png";
const importance = "https://batch-32.imgix.net/importance.png";
const models = "https://batch-32.imgix.net/models.png";
const persona = "https://batch-32.imgix.net/persona.png";
const summary = "https://batch-32.imgix.net/summary.png";
const topics_vis = "https://batch-32.imgix.net/topics_vis.png";
const sent_dist = "https://batch-32.imgix.net/sent_dist.png";
const positive = "https://batch-32.imgix.net/positive.png";
const negative = "https://batch-32.imgix.net/negative.png";

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		topBlockContainer: {
			width: isMobile ? "100%" : "1500px",
			marginLeft: isMobile ? "3px" : "100px",
			overflow: "hidden",
		},
		topBlockBackground: {
			backgroundSize: "100vw 100%",
			height: isMobile ? "2450px" : "3700px",
			justifyContent: "center",
			display: "flex",
			boxShadow: BOX_SHADOWS,
		},
		prodFeatures: {
			fontFamily: FONTS,
			fontSize: "25px",
			fontWeight: "bold",
			textAlign: "center",
			marginTop: "30px",
		},
		banner: {
			fontFamily: FONTS,
			color: "rgba(0,0,0,0.7)",
			fontSize: "18px",
			fontWeight: "bold",
			textAlign: "center",
			marginTop: "5px",
			marginBottom: "50px",
		},
		featureContainer: {
			marginTop: isMobile ? "10px" : "60px",
			display: "flex",
			marginBottom: "70px",
			flexDirection: isMobile ? "column" : "row",
		},
		textSection: {
			display: "flex",
			flexDirection: "column",
			width: isMobile ? "100%" : "900px",
			marginRight: "40px",
		},
		imageSection: { width: "100%" },
		imageSection2: {
			flexDirection: "column",
			display: "flex",
			width: "100%",
		},
		featureLine: {
			fontFamily: "nationalweb,Helvetica,Arial,sans-serif",
			fontSize: "18px",
			fontWeight: 200,
			wordWrap: "break-word",
			lineHeight: "32px",
		},
		featureTitle: {
			fontSize: isMobile ? "25px" : "30px",
			// fontFamily: FONTS,
			fontWeight: 600,
			lineHeight: "40px",
			marginBottom: "10px",
			fontFamily: "nationalweb,Helvetica,Arial,sans-serif",
			textAlign: isMobile ? "center" : "left",
		},
		modelsImage: {
			borderRadius: "10px",
			width: "800px",
			boxShadow: BOX_SHADOWS,
		},
		modelsImageNoShadow: { width: "800px" },
	});
});

export function ProductFeatures() {
	const classes = useStyles();
	return (
		<div className={classes.topBlockBackground}>
			<div className={classes.topBlockContainer}>
				<h2 className={classes.prodFeatures}>
					{isMobile
						? "A Complete ML Toolset"
						: "A Complete Toolset for No-Code ML"}
				</h2>
				<h3 className={classes.banner}>
					Build advanced ML models and gain insights into your data
					with Dash AI.
				</h3>
				{isMobile ? <Line></Line> : <div></div>}
				<AutomatedML></AutomatedML>
				<Line></Line>
				<Importance></Importance>
				<Line></Line>
				<Persona></Persona>
				<Line></Line>
				<Batch></Batch>
				<Line></Line>
				<Analysis></Analysis>
				<Line></Line>
				<Sentiment></Sentiment>
			</div>
		</div>
	);
}

function AutomatedML() {
	const classes = useStyles();
	return (
		<div className={classes.featureContainer}>
			<div
				className={classes.textSection}
				style={{ marginTop: isMobile ? "10px" : "30px" }}
			>
				<h2 className={classes.featureTitle}>
					Automated Machine Learning
				</h2>
				{isMobile ? (
					<div></div>
				) : (
					<ul
						className={styles.dashed}
						style={{ marginLeft: "-30px" }}
					>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}Automatic data cleaning and
							transformation {String.fromCharCode(8212)} no
							tedious data preperation required
						</li>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}Eight state-of-the-art ML
							models to drive insights
						</li>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}Algorithmic analysis to
							produce a single, optimized ensamble model
						</li>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}'Fast Training' mode for
							quick experimentation and results
						</li>
					</ul>
				)}
			</div>
			<div
				className={classes.imageSection}
				style={{ marginRight: "30px" }}
			>
				<img
					src={models}
					className={classes.modelsImage}
					style={{
						marginLeft: "10px",
						width: isMobile ? "96%" : "850px",
					}}
				></img>
			</div>
		</div>
	);
}

function Importance() {
	const classes = useStyles();
	return (
		<div className={classes.featureContainer}>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					overflow: "visible",
				}}
			>
				{isMobile ? (
					<h2 className={classes.featureTitle}>
						Variable Importance and Impact Analysis
					</h2>
				) : (
					<div></div>
				)}
				<div className={classes.imageSection}>
					<img
						src={impact}
						className={classes.modelsImage}
						style={{
							marginLeft: "5px",
							width: isMobile ? "90%" : "700px",
						}}
					></img>
					<img
						src={importance}
						className={classes.modelsImage}
						style={{
							marginTop: isMobile ? "-100px" : "-250px",
							marginLeft: isMobile ? "30px" : "80px",
							width: isMobile ? "90%" : "700px",
						}}
					></img>
				</div>
			</div>
			{isMobile ? (
				<div></div>
			) : (
				<div
					className={classes.textSection}
					style={{ marginTop: "100px" }}
				>
					<h2 className={classes.featureTitle}>
						Variable Importance and Impact Analysis
					</h2>
					<ul
						className={styles.dashed}
						style={{ marginLeft: "-30px" }}
					>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}ML models analyze your data
							to determine which variables are the most impactful
							to your target{" "}
						</li>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}See how varying your input
							values affects your target output
						</li>
						{/* <li className={classes.featureLine}>
            {String.fromCharCode(32)}Algorithmic analysis to produce a single,
            optimized ensamble model
          </li> */}
					</ul>
				</div>
			)}
		</div>
	);
}

function Persona() {
	const classes = useStyles();
	return (
		<div className={classes.featureContainer}>
			<div
				className={classes.textSection}
				style={{ marginTop: isMobile ? "10px" : "140px" }}
			>
				<h2 className={classes.featureTitle}>Persona Prediction</h2>
				{isMobile ? (
					<div></div>
				) : (
					<ul
						className={styles.dashed}
						style={{ marginLeft: "-30px" }}
					>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}Create scenarios with
							'Personas' for one-off predictions
						</li>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}Instant results from your
							optimzed ensamble of ML models
						</li>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}Save up to 20 'Personas' on
							the cloud for future real-time experimentation
						</li>
					</ul>
				)}
			</div>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					overflow: "visible",
				}}
			>
				<div className={classes.imageSection}>
					<img
						src={persona}
						className={classes.modelsImageNoShadow}
						style={{ width: "96%" }}
					></img>
				</div>
			</div>
		</div>
	);
}

function Batch() {
	const classes = useStyles();
	return (
		<div className={classes.featureContainer}>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					overflow: "visible",
				}}
			>
				{isMobile ? (
					<h2 className={classes.featureTitle}>
						Prediction on Large Data
					</h2>
				) : (
					<div></div>
				)}
				<div
					className={classes.imageSection}
					style={{ width: isMobile ? "97%" : "830px" }}
				>
					<img
						src={batch_probs}
						className={classes.modelsImage}
						style={{
							marginLeft: "5px",
							width: isMobile ? "90%" : "700px",
						}}
					></img>
					<img
						src={batch_pie}
						className={classes.modelsImage}
						style={{
							marginTop: "-260px",
							marginLeft: "50px",
							width: isMobile ? "90%" : "700px",
						}}
					></img>
					<img
						src={batch_chart}
						className={classes.modelsImage}
						style={{
							marginTop: "-260px",
							marginLeft: "100px",
							width: isMobile ? "90%" : "700px",
						}}
					></img>
				</div>
			</div>
			<div
				className={classes.textSection}
				style={{ marginTop: isMobile ? "10px" : "150px" }}
			>
				{isMobile ? (
					<div></div>
				) : (
					<div className={classes.featureTitle}>
						Prediction on Large Data
					</div>
				)}
				{isMobile ? (
					<div></div>
				) : (
					<ul
						className={styles.dashed}
						style={{ marginLeft: "-30px" }}
					>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}Drag and drop a new dataset
							to produce a set of predictions for all datapoints
						</li>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}Analysis tools to view the
							distribution of predictions
						</li>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}Confidence levels and
							scores for each prediction allows you to rank your
							results
						</li>
					</ul>
				)}
			</div>
		</div>
	);
}

function Sentiment() {
	const classes = useStyles();
	return (
		<div className={classes.featureContainer}>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					overflow: "visible",
				}}
			></div>
			{isMobile ? (
				<h2 className={classes.featureTitle}>
					Sentiment Analysis and Topic Modeling
				</h2>
			) : (
				<div></div>
			)}
			<div
				className={classes.imageSection2}
				style={{ width: isMobile ? "90%" : "820px" }}
			>
				<img
					src={sent_dist}
					className={classes.modelsImage}
					style={{
						marginLeft: "5px",
						width: isMobile ? "100%" : "720px",
					}}
				></img>
				<img
					src={topics_vis}
					className={classes.modelsImage}
					style={{
						marginLeft: "40px",
						width: isMobile ? "90%" : "740px",
						marginTop: isMobile ? "-120px" : "-320px",
					}}
				></img>
				<img
					src={positive}
					className={classes.modelsImage}
					style={{
						marginTop: isMobile ? "-90px" : "-220px",
						marginLeft: isMobile ? "70px" : "130px",
						borderRadius: "10px",
						width: isMobile ? "120%" : "550px",
					}}
				></img>
				<div style={{}}>
					<img
						src={negative}
						className={classes.modelsImage}
						style={{
							marginLeft: isMobile ? "30px" : "340px",
							marginBottom: "50px",
							marginTop: isMobile ? "-30px" : "20px",
							width: isMobile ? "90%" : "450px",
							borderRadius: "10px",
						}}
					></img>
				</div>
			</div>
			{isMobile ? (
				<div></div>
			) : (
				<div
					className={classes.textSection}
					style={{ marginTop: "80px", marginLeft: "50px" }}
				>
					<h2 className={classes.featureTitle}>
						Sentiment Analysis and Topic Modeling
					</h2>
					<ul
						className={styles.dashed}
						style={{ marginLeft: "-30px" }}
					>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}View the most common themes
							and topics in your text data
						</li>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}Automatically cluster
							similar text items together for easier analysis
						</li>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}Classify text as positive
							and negative with sentiment analysis
						</li>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}Extract the most frequent
							positive and negative topics
						</li>
					</ul>
				</div>
			)}
		</div>
	);
}
function Analysis() {
	const classes = useStyles();
	return (
		<div className={classes.featureContainer}>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					overflow: "visible",
				}}
			></div>
			<div
				className={classes.textSection}
				style={{ marginTop: isMobile ? "10px" : "80px" }}
			>
				<h2 className={classes.featureTitle}>Data Analysis Tools</h2>
				{isMobile ? (
					<div></div>
				) : (
					<ul
						className={styles.dashed}
						style={{ marginLeft: "-30px" }}
					>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}View your data from every
							angle with integrated tools
						</li>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}See how columns relate and
							interact with eachother
						</li>
						<li className={classes.featureLine}>
							{String.fromCharCode(32)}Automated cleaning
							algorithms plus tools to quickly apply custom
							cleaning and filtering
						</li>
					</ul>
				)}
			</div>
			<div
				className={classes.imageSection}
				style={{ width: isMobile ? "90%" : "820px" }}
			>
				<img
					src={summary}
					className={classes.modelsImage}
					style={{
						marginLeft: "5px",
						width: isMobile ? "90%" : "700px",
					}}
				></img>
				<img
					src={dist}
					className={classes.modelsImage}
					style={{
						marginTop: isMobile ? "-100px" : "-230px",
						marginLeft: "50px",
						width: isMobile ? "90%" : "700px",
					}}
				></img>
				<div style={{ width: isMobile ? "90%" : "1000px" }}>
					<img
						src={cor1}
						className={classes.modelsImage}
						style={{
							marginTop: isMobile ? "-100px" : "-250px",
							marginLeft: isMobile ? "50%" : "100px",
							width: isMobile ? "70%" : "485px",
							borderRadius: "10px",
						}}
					></img>
					<img
						src={cor2}
						className={classes.modelsImage}
						style={{
							marginTop: isMobile ? "-300px" : "-300px",
							marginLeft: isMobile ? "15%" : "20px",
							width: isMobile ? "100%" : "208px",
							borderRadius: "10px",
						}}
					></img>
				</div>
			</div>
		</div>
	);
}
